export const CommentSortEnum = {
  NEWEST: 'newest',
  OLDEST: 'oldest'
} as const;

export type CommentSortEnum =
  (typeof CommentSortEnum)[keyof typeof CommentSortEnum];
